import PocketBase from 'pocketbase';
import cookie from 'cookie';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const pb = new PocketBase(config.public.pocketbaseUrl);

  // --- Server-Side ---
  if (import.meta.server) {
    const req = nuxtApp.ssrContext.event.node.req;
    if (req.headers.cookie) {
        const parsed = cookie.parse(req.headers.cookie);
        // Assume the cookie value is stored as a JSON string under 'pb_auth'
        if (parsed.pb_auth) {
            try {
                const authData = JSON.parse(parsed.pb_auth);
                pb.authStore.save(authData.token, authData.record);
            } catch (error) {
                console.error("Error parsing auth cookie on server:", error);
            }
        }
    }
  }

  // --- Client-Side: Restore and Sync Auth ---
  if (import.meta.client) {
    const authCookie = useCookie('pb_auth', {
      maxAge: 7 * 24 * 60 * 60,
      path: '/',
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax'
    });
    if (authCookie.value) {
      try {
        pb.authStore.save(authCookie.value.token, authCookie.value.record);
      } catch (error) {
        console.error("Error loading auth from cookie", error);
        authCookie.value = null;
      }
    }
    // Automatically update cookie when authStore changes.
    pb.authStore.onChange((token, record) => {
      authCookie.value = { token, record };
    }, true);
  }

  // Inject PocketBase instance so it’s accessible in your app.
  nuxtApp.provide('pb', pb);
});
